import React, { Component } from 'react';
import { Link } from "react-router-dom";

class ProjectThumb extends Component {
  render() {
    return (
    <Link className='project-thumb' to={this.props.page} style={{backgroundImage:`url(${this.props.image}`}}>
      <div className='project-thumb-header'>{this.props.name}</div>
      <div className='project-thumb-tech'>{this.props.tech}</div>
    </Link>
    );
  }
}

ProjectThumb.defaultProps = {
  page : "."
}

export default ProjectThumb;